import api from "../api";
import { toast } from 'vue3-toastify'

export default {
    namespaced: true,
    state: {
        data: {},
        callback: {}
    },
    getters: {

    },
    actions: {

        async get_bling_configuration({ commit }) {
            try {
                api.get("/v1/bling/get-bling-configuration")
                    .then((res) => {
                        commit("SET_BLING_DATA", res.data);
                    })
                    .catch((error) => {
                        commit("ERROR_BLING", "Erro ao carregar");
                    })
                    .finally(() => (
                        // this.loading = false
                        console.log('login request end')
                    ));
            } catch (e) {
                commit("ERROR_BLING", e);
            }
        },

        async set_bling_credentials({ commit }, payload = []) {
            try {
                api.post("/v1/bling/create-or-update", payload)
                    .then((res) => {
                        commit("SET_BLING_DATA", res?.data);
                        toast.success("Salvo com sucesso", {
                            type: 'default',
                            theme: 'colored',
                            hideProgressBar: true,
                            dangerouslyHTMLString: true
                        });
                    })
                    .catch((error) => {
                        commit("ERROR_BLING", "Erro ao carregar");
                        toast.warning("Erro ao criar ao salvar credenciais bling", {
                            type: 'default',
                            theme: 'colored',
                            hideProgressBar: true,
                            dangerouslyHTMLString: true
                        });
                    })
                    .finally(() => (
                        // this.loading = false
                        console.log('login request end')
                    ));
            } catch (e) {
                commit("ERROR_BLING", e);
            }
        },

        async request_auth({ commit }) {
            try {
                api.get("/v1/bling/request_auth")
                    .then((res) => {
                        commit("SET_CALLBACK", res.data);
                    })
                    .catch((error) => {
                        commit("ERROR_BLING", "Erro ao carregar");
                    })
                    .finally(() => (
                        // this.loading = false
                        console.log('login request end')
                    ));
            } catch (e) {
                commit("ERROR_BLING", e);
            }
        },

    },
    mutations: {
        SET_BLING_DATA(state, data) {
            state.data = data;
        },
        ERROR_BLING(state, data) {
            console.log(data);
        },
        SET_CALLBACK(state, data){
            state.callback = data
        }

    }
}